import React,{useEffect,useState} from "react";
import {Table,Select,Form,Input,Modal,Button,Flex,Row,Col,Upload,message,DatePicker,Space,Alert,Card,Popconfirm,Image,Typography} from "antd";
import {InboxOutlined,CloseOutlined,EditOutlined,FilterOutlined} from "@ant-design/icons";
import useBroker from "../../hooks/useBroker";
import useServer from "../../hooks/useServer";
import useCustomer from "../../hooks/useCustomer";
import AxiosService from "../../services/APIService";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import moment from "moment";

const {Option} = Select;
const {Dragger} = Upload;
const wlCol = [
    {
        title: "#",
        dataIndex: "index",
        key: "index",
        width: 50
    },
    {
        title: "White Label",
        dataIndex: "whiteLabel",
        key: "whiteLabel",
    }
]
function WLCloseUserList({permission,user,isLoading}) {
    const apiService = new AxiosService()
    const [createdUserList,setCreatedUserList] = useState([]);
    const {brokerList} = useBroker()
    const {customerList} = useCustomer({})
    const [form2] = Form.useForm()
    const [filterShow,setFilterShow] = useState(false);
    const [searchText,setSearchText] = useState("");
    const [docUrl,setDocUrl] = useState("")
    const [isPreviewVisible,setPreviewVisible] = useState(false);
    const {serverList} = useServer()
    const columns = [
        {
            title: "#",
            dataIndex: "count",
            key: "count",
            fixed: 'left',
            width: "50px"
        },
        {
            title: "Bot Id",
            dataIndex: "cutId",
            key: "custId",
            fixed: 'left',
            width: "100px"
        },
        {
            title: "Account Name",
            dataIndex: "name",
            key: "name",
            fixed: 'left',
            render: (e,rec) => <Link to={`/user-profile?userId=${rec.key}`}>Mr. {e}</Link>
        },
        {
            title: "Account Number",
            dataIndex: "accNo",
            key: "accNo",
        },
        (user?.role != "WHITE_LABEL" && {
            title: "Action",
            key: "action",
            dataIndex: "action",
            render: (e,rec) => (permission?.customer === "EDIT" || user?.role !== "SUBADMIN") &&
                <Space>
                    <Button type="default" size={"middle"} onClick={() => onActivateCustomer(rec.key)}>Re-Activate</Button>
                    <Popconfirm
                        description="Are you sure you want to delete this account?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deleteCustomer(rec.key)}
                    >
                        <Button icon={<CloseOutlined />} danger size={"middle"} />
                    </Popconfirm>
                </Space>
        }),
        {
            title: "IB Name",
            dataIndex: "ibName",
            key: "ibName",
        },
        {
            title: "Broker",
            dataIndex: "broker",
            key: "broker",
        },
        {
            title: "Username",
            dataIndex: "username",
            key: "username",
        },
        {
            title: "Password",
            dataIndex: "password",
            key: "password",
        },
        {
            title: "Account Reference By",
            dataIndex: "reference",
            key: "reference",
        },
        {
            title: "Date of Birth",
            dataIndex: "dob",
            key: "dob",
        },
        {
            title: "Master Password",
            dataIndex: "masterPassword",
            key: "masterPassword",
        },
        {
            title: "Investor Password",
            dataIndex: "investorPassword",
            key: "investorPassword",
        },
        {
            title: "Portal Link",
            dataIndex: "portalLink",
            key: "portalLink",
        },
        {
            title: "Password (Portal)",
            dataIndex: "portalPassword",
            key: "portalPassword",
        },
        {
            title: "Server Broker",
            dataIndex: "brokerServer",
            key: "brokerServer",
        },
        {
            title: "VPS Broker",
            dataIndex: "vpsServer",
            key: "vpsServer",
        },
        {
            title: "Phone Number",
            dataIndex: "phNo",
            key: "phNo",
        },
        {
            title: "Whatsapp Number",
            dataIndex: "wpNum",
            key: "wpNum",
        },
        {
            title: "Document",
            dataIndex: "doc",
            key: "doc",
            render: (_,rec) => <Space>
                <Image
                    width={0}
                    preview={{
                        visible: isPreviewVisible,
                        onVisibleChange: (visible,prevVisible) => {
                            setPreviewVisible(visible)
                            setDocUrl("")
                        },
                    }}
                    src={docUrl}
                />
                <Button type="default" onClick={() => imagePreviewOpen("document1",rec)}>Doc 1</Button>
                <Button type="default" onClick={() => imagePreviewOpen("document2",rec)}>Doc 2</Button>
            </Space>
        },
        {
            title: "Address",
            dataIndex: "address",
            key: "address",
        },
        {
            title: "City",
            dataIndex: "city",
            key: "city",
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
        },
        {
            title: "Country",
            dataIndex: "country",
            key: "country",
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            key: "pincode",
        },
    ].filter(Boolean);

    const onActivateCustomer = (id) => {
        apiService.post(`/customer/activate-customer/${id}`)
            .then((res) => {
                fetchCreatedUsers({})
                message.success(res.message)
            })
            .catch(e => {
                message.error(e.message)
            })
    }
    const deleteCustomer = (id) => {
        apiService.delete(`/customer/delete-customer/${id}`)
            .then((res) => {
                fetchCreatedUsers({})
                message.success(res.message)
            })
            .catch(e => {
                message.error(e.message)
            })
    }
    const imagePreviewOpen = (doc,rec) => {
        setDocUrl(`${process.env.REACT_APP_API_URL}doc/${rec?.record?.user?._id}/${doc}`)
        setPreviewVisible(true)
    }

    useEffect(() => {
        fetchCreatedUsers()
    },[]);

    const fetchCreatedUsers = (val) => {
        apiService.get('/customer/whitelabel-user',{
            closed_user: true,
            ...val
        })
            .then(res => {
                const data = res.data.map((dt,i) => ({
                    count: i + 1,
                    key: dt?._id,
                    whiteLabel: dt?.wl?.name,
                    data: dt
                }));
                setCreatedUserList(data)
                // const list = res.data.map((cst,index) => ({
                //     
                // }))
                // setCreatedUserList(list)
            })
            .catch(e => {console.log(e)})
    }
    const filterHandle = (val) => {
        fetchCreatedUsers({
            botStatus: val.botStatus,
            brokerName: val.brokerName,
            ibName: val.ibName,
            refName: val.refName,
            usrStatus: val.status,
            vpsServer: val.vpsServer
        })
    }
    const resetFilter = () => {
        fetchCreatedUsers({})
        form2.resetFields()
    }

    const filterData = (searchTxt) => {
        return createdUserList.filter(dt => dt.name.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.state.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.country.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.pincode.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.city.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.cutId.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.name.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.accNo.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.username.toLowerCase().includes(searchTxt.toLowerCase()) ||
            dt.password.toLowerCase().includes(searchTxt.toLowerCase()))
    }
    const expandedRowRender = (val) => {
        const data = val.data.customers.map((cst, index) => ({
            count: index + 1,
            key: cst?._id,
            cutId: cst?.cust_code,
            name: cst?.user?.fullName,
            accNo: cst?.account_number || "-",
            botStatus: cst?.botStatus,
            status: cst?.user?.status,
            reference: cst?.reference_by?.fullName || "-",
            ibName: cst?.broker?.ib_name || "-",
            broker: cst?.broker?.name || "-",
            record: cst,
            username: cst?.user?.email,
            password: cst?.user?.password,
            dob: moment(cst?.dob).format("DD-MM-YYYY"),
            masterPassword: cst?.master_password,
            investorPassword: cst?.investor_password,
            portalLink: cst?.portal_link,
            portalPassword: cst?.portal_password,
            brokerServer: cst?.server,
            address: cst?.address?.street,
            city: cst?.address?.city,
            state: cst?.address?.state,
            country: cst?.address?.country,
            pincode: cst?.address?.pincode,
            vpsServer: cst?.server_vps?.vps_ip,
            phNo: cst?.contact_no?.phone_no,
            wpNum: cst?.contact_no?.whatsapp_no
        }))
        return <Table loading={isLoading} columns={columns} dataSource={data} />
    }
    return (
        <>
            <Typography.Title level={3} className="page-title">Closed Users</Typography.Title>
            <Flex justify="end" style={{marginBottom: "20px"}}>
                <Input style={{marginRight: 5,maxWidth: 200}} placeholder="Search..." onChange={(e) => setSearchText(e.target.value)} />
                <Button type="primary" style={{marginRight: 5}} onClick={() => setFilterShow(!filterShow)}><FilterOutlined /></Button>
            </Flex>
            {filterShow && (<Card style={{marginBottom: "20px"}}>
                <Form
                    form={form2}
                    layout="vertical"
                    onFinish={filterHandle}
                >
                    <Row gutter={16}>
                        <Col span={4}>
                            <Form.Item name="refName">
                                <Select placeholder="Select Reference" allowClear showSearch options={customerList.map(cst => ({
                                    value: cst?.user?._id,
                                    label: cst?.user?.fullName
                                }))} filterOption={(input,option) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                } />
                            </Form.Item>
                        </Col>
                        {/* <Col span={4}>
                            <Form.Item name="brokerName">
                                <Select allowClear placeholder="Select Broker">
                                    {brokerList.map(bkr => <Option key={bkr._id} value={bkr._id}>{bkr.name}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col span={4}>
                            <Form.Item name="ibName">
                                <Select allowClear placeholder="Select IB">
                                    {[...new Set(brokerList.map(item => item.ib_name))].map(bkr => <Option key={bkr} value={bkr}>{bkr}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item name="vpsServer">
                                <Select allowClear placeholder="Select VPS Server">
                                    {serverList.map(dt => <Option value={dt._id}>{dt.vps_ip}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Space>
                                <Button type="primary" htmlType="submit" loading={isLoading}>Filter</Button>
                                <Button type="default" onClick={resetFilter}>Reset</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>)}
            <Table loading={isLoading} scroll={{x: 4700}} columns={wlCol} dataSource={createdUserList} expandable={{expandedRowRender}} />

        </>
    );
}
const mapStateToProps = ({login,loading}) => {
    const {permission,user} = login
    const {isLoading} = loading
    return {permission,user,isLoading}
}
export default connect(mapStateToProps,{})(WLCloseUserList);